<script>
    import { page } from '$app/stores';
    import Breadcrumbs from '$lib/Breadcrumbs.svelte';
    import PageLayout from '$lib/PageLayout.svelte';
    import PageSection from '$lib/PageSection.svelte';
    import PuzzleCard4 from '$lib/PuzzleCard4.svelte';
    import PuzzleCard3 from '$lib/PuzzleCard3.svelte';
    import Card from '$lib/Card.svelte';
    import H2 from '$lib/H2.svelte';
    import ScrollableSection from '$lib/ScrollableSection.svelte';
    import Courses from '$lib/Courses.svelte';
    import Worksheets from '$lib/Worksheets.svelte';
    import Prose from '$lib/Prose.svelte';
    import { make_banner_at } from '../puzzles_banners';

    let worksheets = $page.data.worksheets || [];
    let courses = $page.data.courses?.filter((c) => c.price) || [];

    const banner_at = make_banner_at($page.data.resolved_banners || []);
</script>

<PageLayout>
    <Breadcrumbs />

    <PageSection>
        {#key $page.data.puzzle.slug}
            <PuzzleCard3 puzzle={$page.data.puzzle} class="mx-auto mb-12" />
        {/key}

        <section>
            <Prose xl class="text-center mb-8 mx-auto">
                <h2>More Puzzles</h2>
                <p>
                    You can <a
                        href="/worksheets/printable-puzzle-cards"
                        class="link">buy a printable version</a
                    > of these puzzles.
                </p>
            </Prose>
            <div class="grid grid-cols-3 gap-2 md:gap-4 lg:gap-8">
                {#each $page.data.puzzles as puzzle, i}
                    {#if puzzle.slug === $page.data.puzzle.slug}
                        <Card aria_label="" class="rounded-lg!" />
                    {:else}
                        <PuzzleCard4 {puzzle} />
                    {/if}
                    {@const banner = banner_at(i)}
                    {#if banner}
                        <svelte:component
                            this={banner.component}
                            {...banner.props}
                            h_level={3}
                            feature="puzzle-inline-{banner.prop_name}"
                            class="col-span-3 my-4"
                        />
                    {/if}
                {/each}
            </div>
        </section>
    </PageSection>

    {#if courses.length > 0}
        <PageSection class="my-12 lg:my-24">
            <H2 lg class="mb-4 lg:mb-8">Courses</H2>

            <ScrollableSection
                class="negate-page-section-px"
                content_class="flex gap-4 md:gap-6 flex-nowrap"
            >
                <Courses
                    {courses}
                    class="snap-center min-w-70 xl:min-w-68"
                    feature="courses-list-puzzle"
                />
            </ScrollableSection>
        </PageSection>
    {/if}

    {#if worksheets.length > 0}
        <PageSection class="my-12 lg:my-24">
            <H2 lg class="mb-4 lg:mb-8">Worksheets</H2>

            <ScrollableSection
                class="negate-page-section-px"
                content_class="flex gap-4 md:gap-6 flex-nowrap"
            >
                <Worksheets
                    {worksheets}
                    h_level={3}
                    class="snap-center min-w-70 xl:min-w-68"
                    feature="worksheets-list-puzzle"
                />
            </ScrollableSection>
        </PageSection>
    {/if}
</PageLayout>
